import * as React from 'react';
var style = {
    borderRadius: '5px',
    fontSize: '11px',
    color: '#fff',
    backgroundColor: '#ff0000',
    padding: '3px 5px',
    margin: '5px'
};
var MessageBadge = function (props) { return (React.createElement("span", { style: style }, props.count)); };
export default MessageBadge;



//////////////////
// WEBPACK FOOTER
// ./src/components/MessageBadge.tsx
// module id = 803
// module chunks = 0